<template>
  <footer>
      <!-- wrap-->
      <div class="container-fluid px-6 pb-5 pt-2">
        <!-- nav-->
        <nav>
          <ul>
            <li><a href="/">Home</a></li>
            <li><router-link
                active-class="text-underline"
                :to="{ name: 'aboutUs' }"
                v-b-tooltip.hover.bottom
              >
                About
              </router-link></li>
            <li><router-link
                active-class="text-underline"
                :to="{ name: 'whatWeOffer' }"
                v-b-tooltip.hover.bottom
              >
                Services
              </router-link></li>
            
            <li><router-link
                active-class="text-underline"
                :to="{ name: 'OurUsers' }"
                v-b-tooltip.hover.bottom
              >
                Target Groups
              </router-link>
             </li>
              <li><a href="/static/PersonalDataProtectionPolicy.pdf" target="_new">Personal Data Protection Policy</a></li>
          </ul>
        </nav>
        <!-- copyright-->
        <div class="subfooter mt-5">
          <div class="image">
            <img width="50" src="/static/img/flag-800.png">
          </div>
          <div class="text">
            <span>
              The <a v-bind:href="project.baseUrl" title="Recipes for Social Innovation" target="_blank">CultureLabs</a> project leading to this application has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement No 770158. The sole responsibility for the content published on this website lies with the authors. The EU is not responsible for any use that may be made of the information contained therein.
            </span>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
  props: {
    'project': Object
  }
}
</script>

<style lang="scss" scoped>
  .custom-bg {
    background-color: #f7f7f7
  }

  .subfooter {
    text-align:left;
    width: 40%;
    font-size: 0.7em;
    line-height: 2em;
    margin-left: 3em;
    display: flex;
    align-items: center;
    justify-content: center;

    .image {
      margin-right: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue